module.exports = "/_next/static/images/main-visual-about-c5e660e8f1becf5ce1cef0312a2ea816.jpg";